export default __webpack_public_path__ + "static/use-case-5.url-53b0507bb4e65153e78c48ee4ef2710a.svg";